<template>
  <div class="context-menu-main" :style="{ top: `${position[0]}px`, left: `${position[1]}px` }">
    <div class="context-item" v-for="c in contextItems" :key="c" @click="contextClicked($event, c)">{{ c }}</div>
    <div class="divider"></div>
    <div class="context-item" @click="closeClicked">Close</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    // Public properties
    contextItems: { type: Array, default: function() { return [] } }, // Array of strings of the context items
    show: { type: Boolean, default: false }, // Use .sync for 2 way binding, will becomes false when the close button is clicked
    position: { type: Array, default: function() { return [ 0, 0 ] } }, // Position of the context menu, [ top, left ]
    clickWithContext: {
      type: Boolean,
      default: false
    }

    // Public events
    // contextSelected - fire when any of the context items is clicked, return the text of the context item
  },
  methods: {
    contextClicked: function(e, item) {
      this.show = false;
      this.$emit('update:show', this.show);
      this.$emit('contextSelected', item);
      this.$emit('contextEvent', e);
    },
    closeClicked: function() {
      this.show = false;
      this.$emit('update:show', this.show);
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.context-menu-main {
  position: absolute;
  font-size: 12px;
  z-index: 999;
  background-color: rgb(30,30,30);
  color: rgb(220,220,220);
  border-radius: 5px;
  max-width: 150px;
  min-width: 150px;
  overflow: hidden;

  > .context-item {
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: rgb(100,100,100);
    }
  }

  > .divider {
    background-color: white;
    height: 1px;
  }
}
</style>